module.exports = __webpack_public_path__ + "static/img/points_global3.cd2a85e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/points_global3.png
// module id = 326
// module chunks = 2